import { Service } from "typedi";
import { Repository } from "./repository";
import { SharedGeoprojet } from "portail-api-models";

@Service()
export class GeoprojectRepository extends Repository<Array<SharedGeoprojet>> {
    clazz = SharedGeoprojet
    key = "geoprojects"
}
